export enum UserType {
    Individual = 1,
    Representative,
    Contractor,
    CharityManager,
    Affiliate    
}